import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../data/store'
import { combineFirstAndLastName, getNetworkResponseError, isStatusOK } from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'

const PRODUCT_ID = '1012222303009777000'
const TYPE = 'Savings'
const beneficiaryType = 'DMR'

const parsedDataBody = (body: any) => {
  return {
    remitterId: body?.remittanceUserId,
    productId: PRODUCT_ID,
    accountNumber: body?.beneficiaryAccountNumber,
    accountHolderName: body?.accountHolderName,
    nickName: combineFirstAndLastName(body?.beneficiaryFirstName ?? '', body?.beneficiaryLastName ?? ''),
    accountType: TYPE?.toUpperCase(),
    ifscCode: body?.ifscCode,
    mobileNumber: {
      countryCode: '91',
      number: body?.mobile,
    },
    beneficiaryType: beneficiaryType,
    createdBy: RootStore?.agent?.session?.CHANNEL_ID,
    createdFromChannel: RootStore?.agent?.session?.CHANNEL_ID,
    field5: 'B93,B94',
  }
}
const responseParser = (data: any) => {
  if (data?.data?.status === 'F') {
    throw {
      code: data.data.errorCode,
      message: data.data.errorMessage,
    }
  }
  if (isStatusOK(data)) {
    const agentStatus = data?.data?.responseObj?.agent?.agentStatus

    if (agentStatus) {
      return agentStatus
    }
    return data?.data?.responseObj
  } else {
    throw getNetworkResponseError(data?.data)
  }
}

export const agentOnboardingApi = (tokens: any, body: any) => {
  let config = sitConfig(tokens) as any
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier

  const agentInfo = RootStore.agent.agentInfo
  const deviceInfo = RootStore.agent.deviceInfo
  const nestedAgent = agentInfo?.agent
  const address = nestedAgent?.address
  //   config.headers['x-jfsUserId'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.jfsUserId || '';
  // config.headers['x-mobileNumber'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.mobileNumber || 'N/A';
  // // config.headers['x-channel-user-id'] = RootStore.agent.agentInfo.agentUserLoginId || '1123766817865366323';
  // config.headers['x-channel-user-id'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.jfsUserId || '1123766817865366323';
  // config.headers['x-intercept-gateway'] = 'SERVICE/JPB';

  const extractPinCode = (addressString) => {
    const match = addressString?.match(/\b\d{6}\b/)
    return match ? match[0] : null
  }

  const StateJSON: Record<string, string> = {
    AN: 'Andaman and Nicobar Islands',
    AP: 'Andhra Pradesh',
    AR: 'Arunachal Pradesh',
    AS: 'Assam',
    BR: 'Bihar',
    CH: 'Chandigarh',
    CG: 'Chhattisgarh',
    DH: 'Dadra and Nagar Haveli and Daman and Diu',
    DL: 'Delhi',
    GA: 'Goa',
    GJ: 'Gujarat',
    HR: 'Haryana',
    HP: 'Himachal Pradesh',
    JK: 'Jammu and Kashmir',
    JH: 'Jharkhand',
    KA: 'Karnataka',
    KL: 'Kerala',
    LA: 'Ladakh',
    LD: 'Lakshadweep',
    MP: 'Madhya Pradesh',
    MH: 'Maharashtra',
    MN: 'Manipur',
    ML: 'Meghalaya',
    MZ: 'Mizoram',
    NL: 'Nagaland',
    OD: 'Odisha',
    PY: 'Puducherry',
    PB: 'Punjab',
    RJ: 'Rajasthan',
    SK: 'Sikkim',
    TN: 'Tamil Nadu',
    TS: 'Telangana',
    TR: 'Tripura',
    UP: 'Uttar Pradesh',
    UK: 'Uttarakhand',
    WB: 'West Bengal',
  }

  const stateCode = nestedAgent?.stateCode || agentInfo.agentUserStateCode || ''

  // 2. Lookup the Full Name. Fallback to the code itself if not found in JSON
  const derivedStateName = StateJSON[stateCode] || stateCode

  const derivedPinCode = nestedAgent?.pinCode || agentInfo?.pinCode || extractPinCode(nestedAgent?.address) || ''

  console.log(`Agent Information ${agentInfo}`)
  console.log(` deviceInfo Information ${deviceInfo}`)
  console.log(` nestedAgent Information ${nestedAgent}`)
  console.log(` nestedAgent address Information ${derivedStateName}`)
  console.log(`Mapped State Code [${stateCode}] to Name [${derivedStateName}]`)

  const requestBody = {
    agent: {
      name: RootStore.agent.agentInfo.agentUserName,
      aliasName: RootStore.agent.agentInfo.agentUserName || '',
      mobileNo: RootStore.agent.agentInfo.agentMobileNumber || '',
      shopName: RootStore.agent.agentInfo.agentUserDealershipName || '',
      businessType: agentInfo.entityType || 'RETAILER' || 'Retail',
      paymentModes: 'Cash,UPI',
      paymentChannels: 'Online',

      registeredAddress: RootStore.agent.agentInfo.agent?.address || agentInfo.agentUserDealerStoreCode || 'N/A',
      registeredState: derivedStateName || nestedAgent?.stateCode || agentInfo.agentUserStateCode || '',
      registeredCity: nestedAgent?.city || agentInfo.agentUserCity || '',
      registeredCountry: 'India',
      registeredPinCode: nestedAgent?.pinCode || derivedPinCode || agentInfo.agentUserPincode || '',

      // registeredPinCode: RootStore.agent.agentInfo.agentUserDealerPinCode || '394655',
      latitude: nestedAgent?.latitude?.toString() || deviceInfo.latitude?.toString() || '0.0',
      longitude: nestedAgent?.longitude?.toString() || deviceInfo.longitude?.toString() || '0.0',

      effectiveFromDate: body?.effectiveFromDate || new Date().toISOString().split('T')[0] || '2025-01-01',
      effectiveToDate: body?.effectiveToDate || '2099-12-31',

      agentInstituteId: body?.agentInstituteId || 'JI02 ' || 'INST123456',
      merchantId: agentInfo.agentUserLoginId,
      merchantUserId: body?.merchantUserId,

      feeInfo: agentInfo.feeInfo || {
        feeType: 'Flat',
        feeAmount: '10.00',
        currency: 'INR',
      },
      customerInfo: agentInfo.customerInfo || {
        customerId: 'CUST001',
        customerName: 'Acme Corp',
      },
      paymentCollectionMode: 'ONLINE',
      consentCode: body?.consentCode || 'B88',
      consentAuthenticationMode: body?.consentAuthenticationMode || 1,
      consentCreatedDateAndTime: new Date().toISOString() || '',
    },
  }

  console.log('requestBody for agentOnboardingApi agentOnboardingApi agentOnboardingApi', requestBody)
  const request: Request<{}> = {
    apiPath: APIEndPoints.bbpsAgentOnboard,
    method: 'POST',
    config: config,
    body: requestBody,
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      console.log('requestBody for agentOnboardingApi agentOnboardingApi agentOnboardingApi', requestBody)
      console.log(
        data,
        'Akanksha see what data we are sending to respponse parse agentOnboardingApi bbpsAgentOnboard',
        data,
      )
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}
